import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { DeviceModel } from "../../models/device.model";
import { DeviceHistoryModel } from "../../models/device.history.model";
import { DeviceService } from "../../services/device.service";
import { AuthenticationService } from '../../services/authentication.service';
import { Ng2SmartTableModule, LocalDataSource } from 'ngx-smart-table';

@Component({
    selector: 'device-history',
    templateUrl: './device-history.component.html',
    styleUrls: ['./device-history.component.css']
})
export class DeviceHistoryComponent {
    historyValues: Array<DeviceHistoryModel>;
    isDataAvailable = false;
    source: LocalDataSource;

    settings = {
        columns: {
          boolValue: {
            title: 'Wert',
            type: 'text',
            valuePrepareFunction: (value) => {
                return value ? 'an' : 'aus';
            },
            editable: false,
            addable: false,
          },
          date: {
            title: 'Datum',
            type: 'text',
            valuePrepareFunction: (value) => {
                return this.transformDate(value);
            },
            editable: false,
            addable: false,
          }
        },
        actions: {
			add: false,
			edit: false,
			delete: false
		},
		editable: false,
      };

    constructor(private router: Router, private http: Http, private authService: AuthenticationService, private deviceService: DeviceService) {
        this.source = new LocalDataSource();
    }
    private checked = false;
    @Input() deviceModel: DeviceModel;

    ngOnInit() {        
        let headers = new Headers({ 'Authorization': 'Bearer ' + this.authService.token });
        let options = new RequestOptions({ headers: headers });
        this.deviceService.getDeviceHistory(this.deviceModel.busIdentifier, 2)
        .subscribe(devices => {
            this.historyValues = devices.data; 
            
            this.source.load(this.historyValues);
        });
    }

    private transformDate(dateString) : string
    {
        var date = new Date(dateString);
        var formatted = new DatePipe('en-EN').transform(date, 'dd.MM.yy HH:mm:ss');
        
        return formatted;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/device-history/device-history.component.ts